import { useContext } from "react";
import TextEditor from "../../components/Table/TextEditor";
import { context } from "../../context/authContext";
import useActions from "./acciones";

export default function useColumns(setSelectedRow,setModalOpen) {
  const { user } = useContext(context);
  const { handleDelete } = useActions();

  const userRoles = user?.rol || [];
  const permisos = userRoles.find((role) => role.nombre === "Empresas")?.permiso || [];
  const isEditable = permisos.includes("editar");
  const canDelete = permisos.includes("borrar");

  return [
    { field: "id", sort: "asc", cellClass: "d-flex align-items-center" },
    ...["nombre","createdAt"].map((field) => ({
      field,
      flex: 2,
      cellClass: "d-flex align-items-center",
      cellEditor: TextEditor,
      editable: field === "createdAt" ? false : isEditable,
      valueFormatter: field === "createdAt" ? (params) =>{
        let date =  `${new Date(params.value).toLocaleDateString("en-GB")} 
        ${new Date(params.value).toLocaleTimeString("en-GB")}` 
        return date }: undefined,
      tooltipValueGetter: (params) => params.data?.[`tooltipError${field}`] || "",
      cellClassRules: {
        "is-invalid": (params) => !!params.data?.[`tooltipError${field}`],
        "is-valid": (params) => !!params.data?.[`isValid${field}`],
      },
    })),
    canDelete && {
      field: "eliminar",
      flex: 2,
      cellClass: "d-flex align-items-center justify-content-center",
      cellRenderer: (data) => (
        <button onClick={() => handleDelete(data, setSelectedRow,setModalOpen)} className="btn btn-primary px-2 py-1">
          🗑️ Eliminar
        </button>
      ),
    },
  ].filter(Boolean);
}
